/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_ProviderInputs */

const en_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Provider`)
};

const fr_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur de service`)
};

const de_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstleister`)
};

const it_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitore di servizi`)
};

const ru_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик услуг`)
};

const es_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor de servicios`)
};

const zh_cn2_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务提供商`)
};

const ja_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスプロバイダー`)
};

const hi_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेवा प्रदाता`)
};

const pt_pt2_service_provider = /** @type {(inputs: Service_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestador de Serviços`)
};

/**
* | output |
* | --- |
* | "Service Provider" |
*
* @param {Service_ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const service_provider = /** @type {((inputs?: Service_ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_service_provider(inputs)
	if (locale === "de") return de_service_provider(inputs)
	if (locale === "it") return it_service_provider(inputs)
	if (locale === "ru") return ru_service_provider(inputs)
	if (locale === "es") return es_service_provider(inputs)
	if (locale === "zh-CN") return zh_cn2_service_provider(inputs)
	if (locale === "ja") return ja_service_provider(inputs)
	if (locale === "hi") return hi_service_provider(inputs)
	if (locale === "pt-PT") return pt_pt2_service_provider(inputs)
	return en_service_provider(inputs)
});